import "./api/platform"; // Configure shared API client for web — must be first
import "@zatio/shared"; // Initializes i18next as a side effect
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
